import { gql } from '@apollo/client';

export const fetchEntitlementsGroupByCloudSite = gql`
  query fetchEntitlementsGroupByCloudSite($invoiceGroupId: ID!) {
    entitlementsGroupByCloudSite(invoiceGroupId: $invoiceGroupId) {
      cloudSiteId
      entries {
        entitlementNumber
        productName
        logoId
        productId
        cloudSiteHostname
        billingFrequency
        endTimestamp
        scheduledChanges {
          subscriptionScheduleAction
        }
        isApp
        isAddOn
        parentEntitlementId
        familyContainerId
        entitlementId
      }
    }
  }
`;
